export default __webpack_public_path__ + "static/yahooFinance-240-378703d02c1bca7029580cfbd3f0a9f9.png";